import {PropsWithChildren} from 'react';
import {Navigate, useLocation} from 'react-router';
import AppStartLoader from 'ui/@_components/app-start-loader';
import {useSafeCurrentCompanyUuid} from 'ui/@atoms/current-company';
import {useCurrentSubscriptions} from 'ui/@hooks/queries/use-current-subscriptions';
import {useCompany} from 'ui/@hooks/queries/use-company';
import {useFullUserProfile} from 'ui/@hooks/queries/use-full-user-profile';
import {useCurrentAuthUser} from 'ui/@hooks/queries/use-current-auth-user';

const USER_SETUP_PATH = 'user-setup';

const OnboardingGuard = ({children}: PropsWithChildren) => {
  const companyUuid = useSafeCurrentCompanyUuid();

  const currentCompany = useCompany({
    variables: {
      companyUuid,
    },
  });

  const currentAuthUser = useCurrentAuthUser();

  const userProfile = useFullUserProfile({
    variables: {
      companyUuid,
    },
  });

  const currentSubscriptions = useCurrentSubscriptions({
    variables: {
      companyUuid,
    },
  });

  const location = useLocation();

  const shouldRedirectToUserSetup = () => {
    if (currentCompany.data?.creatorUuid === currentAuthUser.data?.uuid)
      return false;

    if (userProfile.data?.fullOnboardingChecklist.hasCreatedProfile)
      return false;
    if (location.pathname.includes(USER_SETUP_PATH)) return false;

    return true;
  };

  if (
    userProfile.isLoading ||
    currentAuthUser.isLoading ||
    currentSubscriptions.isLoading ||
    currentCompany.isLoading
  ) {
    return <AppStartLoader />;
  }

  if (shouldRedirectToUserSetup()) {
    return <Navigate replace to={USER_SETUP_PATH} />;
  }

  return <>{children}</>;
};

export default OnboardingGuard;
